import "./brokerConvenienceTestQuestionContainer.scss";
// @vendors
import React from "react";
import PropTypes from "prop-types";

// @components
import BrokerConvenienceTestAccordionRow from '../brokerConvenienceTestAccordionQuestion/brokerConvenienceTestAccordionRow/brokerConvenienceTestAccordionRow';
import BrokerConvenienceTestRadioQuestion from "../brokerConvenienceTestRadioQuestion/brokerConvenienceTestRadioQuestion";
import BrokerConvenienceTestSpinnerQuestion from "../brokerConvenienceTestSpinnerQuestion/brokerConvenienceTestSpinnerQuestion";
import BrokerConvenienceTestTextQuestion from "../brokerConvenienceTestTextQuestion/brokerConvenienceTestTextQuestion";
import BrokerConvenienceTestBoxesQuestion from '../brokerConvenienceTestBoxesQuestion/brokerConvenienceTestBoxesQuestion';
import BrokerConvenienceTestSustainabilityStep from "../brokerConvenienceTestSustainabilityStep/brokerConvenienceTestSustainabilityStep";
import BrokerConvenienceTestModalQuestion from "../brokerConvenienceTestModalQuestion/brokerConvenienceTestModalQuestion";
import OKModal from 'components/commons/OKModal/OKModal';

// @Utils
const { formatText } = require("core/i18n").i18n;
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');

// @Constants
const {
    QUESTION_TYPE_ACCORDION,
    QUESTION_TYPE_SPINNER,
    QUESTION_TYPE_TEXT,
    QUESTION_TYPE_BOXES,
    QUESTION_TYPE_MODAL,
} = require("ok-mifid/constants/constants");

class BrokerConvenienceTestQuestionContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isFirstRender: true };
    }

    componentDidMount() {
        this.setState(() => {
            if (this.state.isFirstRender) {
                this.buildTagging();
                return { isFirstRender: false };
            }
        });
    }

    componentDidUpdate(prevProps) {
        const { currentStepCategory, currentStepSubCategory } = this.props;

        const isCategoryChange =
            prevProps.currentStepCategory !== currentStepCategory;
        const isSubcategoryChange =
            prevProps.currentStepSubCategory !== currentStepSubCategory;

        if (isCategoryChange || isSubcategoryChange) {
            this.buildTagging();
        }
    }

    buildTagging() {
        const { currentCategoryName, currentSubCategoryName, currentStep } =
            this.props;

        const customData = {
            nombrePagina: "tu inviertes/test-mifid",
            tipoProceso: "proc-tu-inviertes-test-mifid",
            pasoProceso: currentStep,
            detalleProceso: currentSubCategoryName || currentCategoryName,
        };
        window &&
            window.utag &&
            window.utag.view &&
            window.utag.view(customData);
    }

    buildSectionTitle(title) {
        if (!!title) {
            return (
                <div className="br-convenience-question__description">
                    {title}
                </div>
            );
        }
    }

    buidSubCategoryHeader(subCategoryTitle, subCategoryDescription) {
        if (!!subCategoryTitle) {
            const description = !!subCategoryDescription ? (
                <div className="br-convenience-question__description">
                    {subCategoryDescription}
                </div>
            ) : null;
            return (
                <div className="">
                    <div className="br-convenience-question__title">
                        {subCategoryTitle}
                    </div>
                    {description}
                </div>
            );
        }
        return null;
    }

    buildModalInvestmentExperience() {
        const {
            immFlagBasedFeatures,
            handleCloseModalInvestmentExperience,
            showInvestmentExperienceModal
        } = this.props;

        if (
            immFlagBasedFeatures.get(
                "wealth_mifid_test_contracted_products_coherence_control"
            )
        ) {
            return (
                <OKModal
                    title={formatText(
                        "broker-convenienceMifidTestInvestmentExperienceTitleModal"
                    )}
                    titleAlignment="center"
                    footerType="action"
                    onCloseCallback={() =>
                        handleCloseModalInvestmentExperience()
                    }
                    onPrimaryButtonClick={() =>
                        handleCloseModalInvestmentExperience()
                    }
                    description="broker-convenienceMifidTestInvestmentExperienceContentModal"
                    isOpen={showInvestmentExperienceModal}
                    primaryButtonText="broker-convenienceMifidTestInvestmentExperienceButtonTextModal"
                />
            );
        }
    }

    buildQuestion(immQuestion, immSection) {
        const modalInvestmentExperience = this.buildModalInvestmentExperience();
        switch (immQuestion.get("inputType")) {
            case QUESTION_TYPE_ACCORDION:
                return (
                    <React.Fragment>
                        <BrokerConvenienceTestAccordionRow
                            key={immQuestion.get("id")}
                            id={immQuestion.get("id")}
                            description={immQuestion.get("description")}
                            pillsConfig={immQuestion.get("answer").reverse()}
                            information={immQuestion.get("information")}
                            icon={immQuestion.get("icon")}
                            sectionId={immSection.get("id")}
                            selectAccordionButton={this.props.updateAnswer}
                            disabled={false}
                            closedToggleText={formatText(
                                "broker-convenienceMifidTestAccordionTogglerClosed"
                            )}
                            openedTogglerText={formatText(
                                "broker-convenienceMifidTestAccordionTogglerOpened"
                            )}
                        />
                        {modalInvestmentExperience}
                    </React.Fragment>
                );
            case QUESTION_TYPE_SPINNER:
                return (
                    <BrokerConvenienceTestSpinnerQuestion
                        key={immQuestion.get("id")}
                        onChange={this.props.updateAnswer}
                        sectionId={immSection.get("id")}
                        answer={immQuestion.get("answer")}
                        questionId={immQuestion.get("id")}
                        question={immQuestion.get("description")}
                        disclaimer={immQuestion.get("disclaimer")}
                    />
                );
            case QUESTION_TYPE_TEXT:
                return (
                    <BrokerConvenienceTestTextQuestion
                        key={immQuestion.get("id")}
                        onChange={this.props.updateAnswer}
                        sectionId={immSection.get("id")}
                        answer={immQuestion.get("answer")}
                        questionId={immQuestion.get("id")}
                        question={immQuestion.get("description")}
                        disclaimer={immQuestion.get("disclaimer")}
                        label={immQuestion.get("label")}
                        footstep={immQuestion.get("footstep")}
                        invalidAnswer={immQuestion.get("invalidAnswer")}
                        invalidAnswerText={immQuestion.get("invalidAnswerText")}
                    />
                );
            case QUESTION_TYPE_BOXES:
                return (
                    <BrokerConvenienceTestBoxesQuestion
                        key={immQuestion.get("id")}
                        onChange={this.props.updateAnswer}
                        sectionId={immSection.get("id")}
                        answer={immQuestion.get("answer")}
                        questionId={immQuestion.get("id")}
                        question={immQuestion.get("description")}
                    />
                );
            case QUESTION_TYPE_MODAL:
                return (
                    <BrokerConvenienceTestModalQuestion
                        key={immQuestion.get("id")}
                        onChange={this.props.updateAnswer}
                        sectionId={immSection.get("id")}
                        answer={immQuestion.get("answer")}
                        questionId={immQuestion.get("id")}
                        question={immQuestion.get("description")}
                        disclaimer={immQuestion.get("disclaimer")}
                        secondDisclaimer={immQuestion.get("secondDisclaimer")}
                        isOpen={immQuestion.get("isOpen")}
                    />
                )
            default:
                return (
                    <BrokerConvenienceTestRadioQuestion
                        key={immQuestion.get("id")}
                        onChange={this.props.updateAnswer}
                        sectionId={immSection.get("id")}
                        answer={immQuestion.get("answer")}
                        questionId={immQuestion.get("id")}
                        question={immQuestion.get("description")}
                        disclaimer={immQuestion.get("disclaimer")}
                        secondDisclaimer={immQuestion.get("secondDisclaimer")}
                    />
                );
        }
    }

    render() {
        const { immCategories, currentStepSubCategory, currentStepCategory, immBrokerConvenienceMiFIDTest } =
            this.props;
        const immSubCategory = immCategories.getIn([
            currentStepCategory,
            "subCategories",
            currentStepSubCategory,
        ]);

        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])

        const subCategoryTitle = immSubCategory.get("subCategoryTitle");
        const subCategoryDescription = immSubCategory.get(
            "subCategoryDescription"
        );
        const subCategoryHeader = this.buidSubCategoryHeader(
            subCategoryTitle,
            subCategoryDescription
        );

        const immSections = immSubCategory.get("sections");

        let content;
        if (isPrivateEquityTest(testToEvaluateId) && currentStepCategory === 3 && currentStepSubCategory === 1) {
                content = ( 
                    <div className="br-convenience-question__container">
                        <BrokerConvenienceTestSustainabilityStep
                            immQuestions={immSections.getIn([0, "questions"])}
                            updateAnswer={this.props.updateAnswer}
                            sectionId={immSections.getIn([0, "id"])}
                        />
                    </div>
                );
            } else {
                content = (
                    <div className="br-convenience-question__container">
                        <div className="br-convenience-question__header">
                            {subCategoryHeader}
                            {!!immSections &&
                                immSections.map((immSection, index) => (
                                    <div key={index}>
                                        {this.buildSectionTitle(immSection.get("name"))}
                                        {immSection
                                            .get("questions")
                                            .map((immQuestion) => this.buildQuestion(immQuestion, immSection))}
                                    </div>
                                ))}
                        </div>
                    </div>
                )
            }
        return content;
    }
}

BrokerConvenienceTestQuestionContainer.propTypes = {
    immCategories: PropTypes.object.isRequired,
    currentStepSubCategory: PropTypes.number.isRequired,
    currentStepCategory: PropTypes.number.isRequired,
    sustainabilityQuestions: PropTypes.string,
    sustainabilityAnswers: PropTypes.array,
    updateAnswer: PropTypes.func.isRequired,
    handleCloseModalInvestmentExperience: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    showInvestmentExperienceModal: PropTypes.bool.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    currentCategoryName: PropTypes.string.isRequired,
    currentSubCategoryName: PropTypes.string.isRequired,
    currentStep: PropTypes.number.isRequired,
};

module.exports = BrokerConvenienceTestQuestionContainer;
